import React from 'react'
import styled from 'styled-components'
import SubmitInfo from '@/components/common/submitInfo'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'Get Exclusive Deal',
    desc: 'Subscribe to get the latest voucher and exclusive promo information via email',
  },
  id: {
    title: 'Dapatkan Penawaran Spesial',
    desc: 'Subscribe untuk dapatkan informasi voucher dan promo eksklusif via email',
  },
})

const ProductBanner = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  return (
    <BannerBox>
      <div className="container">
        <div className="left">
          <h1 className="title">{t('title')}</h1>
          <h2 className="subtitle">{t('desc')}</h2>
          <Reveal animation={Animation.FadeIn}>
            <LazyLoad>
              <img
                className="banner-product"
                src={`/images/product/${width > 1000 ? 'banner-product.png' : 'mobile-product.png'}`}
                alt="Kreditpintar Dapatkan penawaran spesial ​& promo"
              />
            </LazyLoad>
          </Reveal>
        </div>
        <SubmitInfo name="product" />
      </div>
    </BannerBox>
  )
}

export default ProductBanner

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    padding-top: 62px;
    background-image: url('/images/product/mobile-product-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      height: 858px;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      img {
        width: 100%;
      }
      .left {
        padding-top: 24px;
        .title {
          font-size: 28px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          /* line-height: 32px; */
        }
        .subtitle {
          padding-top: 8px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 20px;
        }
        .banner-product {
          position: absolute;
          bottom: 66px;
          right: 0;
          width: 258px;
          height: 258px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    background-image: url('/images/product/banner-product-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      height: 612px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 150px;
      img {
        width: 100%;
      }
      .left {
        position: relative;
        padding-top: 45px;
        width: 620px;
        .title {
          font-size: 44px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          margin-bottom: 10px;
        }
        .subtitle {
          width: 543px;
          padding-top: 5px;
          font-size: 28px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 36px;
          margin-top: 0px;
        }
        .banner-product {
          position: absolute;
          bottom: 20px;
          left: 70px;
          width: 349px;
          height: 358px;
        }
      }
    }
  }
`
